import React from 'react';
import styled, { keyframes } from 'styled-components';
import botSleepZZZ from 'assets/images/botSleepZZZ.svg';
import GlitchEffect from './glitchEffect';

/* eslint-disable */

const cloudMovement = keyframes`
  1% {
    opacity: 0;
  }

  2% {
    visibility: visible;
    opacity: 1;
    transform: translateX(-82%);
  }
  
  50% {
    opacity: 1;
  }

  98% {
    transform: translateX(82%);
  }
  100% {
    opacity: 0;
  }
`;

const sunScale = keyframes`
  0%{
    transform: scale(1) translateY(10px);
  }
  
  50% {
    transform: scale(1.2) translateY(10px);
  }
  
  100%{
    transform: scale(1) translateY(10px);
  }
`;

const upDownAnimation = keyframes`
  0% {
    transform: translateY(0);
  }
  
  50% {
    transform: translateY(10px);
  }
  
  0% {
    transform: translateY(0);
  }
`;

const CloudGroup = styled.g`
  transform: translateX(-82%);
  animation: ${cloudMovement} 20s linear infinite;
`;

const Cloud = styled.path`
  animation: ${upDownAnimation} ${props => props.duration}s ease-in-out infinite;
`;

const SunGroup = styled.g`
  animation: ${sunScale} 5s linear infinite;
  transform-origin: 79% 8%;
`;

const redPlantAnimation = keyframes`
  0% {
    transform: skewX(0deg);
  }
  
  25% {
    transform: skewX(-10deg);
  }
  
  75% {
    transform: skewX(10deg);
  }
  
  100% {
    transform: skewX(0);
  }
`;

const yellowPlantAnimation = keyframes`
  0% {
    transform: skewX(3deg);
  }
  
  35% {
    transform: skewX(-7deg);
  }
  
  65% {
    transform: skewX(13deg);
  }
  
  100% {
    transform: skewX(3);
  }
`;

const RedPlant = styled.g`
  animation: ${redPlantAnimation} 10s cubic-bezier(0.81, 0.68, 0.23, 0.72) infinite;
  transform-origin: 10% 100%;
  transform: skewX(0deg);
`;

const YellowPlant = styled.g`
  animation: ${yellowPlantAnimation} 10s cubic-bezier(0.5, 0.61, 0.23, 0.72) infinite;
  transform: skewX(3deg);
  transform-origin: 15% 100%;
`;

const eyeAnimation = keyframes`
  0% {
    transform: scaleY(1);
    fill: #DEE3F3;
  }
  
  34% {
    transform: scaleY(1);
    fill: #DEE3F3;
  }
  
  50% {
    transform: scaleY(0.3);
    fill: #FFD037;
  }
  
  66% {
    transform: scaleY(1);
    fill: #DEE3F3;
  }
  
  100% {
    transform: scaleY(1);
    fill: #DEE3F3;
  }
`;

const closeEyesAnimation = keyframes`
  0% {
    transform: scaleY(1);
  }
  100% {
    transform: scaleY(0.1);
  }
`;

const Eye = styled.g`
  animation: ${props => (props.state === 'awake' ? eyeAnimation : closeEyesAnimation)}
    ${props => (props.state === 'awake' ? '6s' : '3s')} ease-in-out
    ${props => (props.state === 'awake' ? 'infinite' : '')};
  transform: scaleY(${props => (props.state === 'awake' ? 1 : 0.1)});
  transform-origin: 50% 43%;
  transition: transform 0.6s ease-in-out;
`;

const Robot = styled.g``;
const World = styled.g`
  filter: grayscale(${props => (props.state === 'awake' ? '0%' : '100%')});
  transition: 2s ease-in-out;
`;

const Head = styled.g`
  transform: ${props => (props.state === 'awake' ? 'rotate(0deg)' : 'rotate(10deg)')};
  transform-origin: 46% 48%;
  transition: 1s ease-in-out;
`;

const BotIllustration = ({ state }) => (
  <div style={{ position: 'relative' }}>
    <div style={{ position: 'absolute', top: 113, left: 121 }}>
      <GlitchEffect
        style={{ opacity: state === 'awake' ? 0 : 1, transition: '2s ease-in' }}
        image={botSleepZZZ}
      />
    </div>
    <svg
      width="283"
      height="207"
      viewBox="0 0 283 207"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <World state={state}>
          <path
            opacity="0.5"
            d="M140.987 206.151C179.878 206.151 211.406 200.855 211.406 194.322C211.406 187.79 179.878 182.494 140.987 182.494C102.095 182.494 70.5671 187.79 70.5671 194.322C70.5671 200.855 102.095 206.151 140.987 206.151Z"
            fill="#DEE3F3"
          />
          <g opacity="0.45">
            <path
              opacity="0.45"
              d="M124.072 71.2363C124.073 71.3688 124.082 71.5011 124.1 71.6324C124.082 71.5011 124.073 71.3688 124.072 71.2363Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M159.535 62.7393C159.535 62.7752 159.535 62.8084 159.551 62.8443C159.546 62.8084 159.54 62.7752 159.535 62.7393Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M159.46 62.3896C159.46 62.4256 159.48 62.4643 159.488 62.5002C159.48 62.4615 159.472 62.4256 159.46 62.3896Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M159.496 71.8994C159.496 71.9602 159.466 72.021 159.449 72.0791C159.469 72.021 159.483 71.9602 159.496 71.8994Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M159.546 71.6104C159.546 71.6739 159.529 71.7403 159.516 71.8038C159.529 71.7403 159.54 71.6739 159.546 71.6104Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M125.712 73.935C125.475 73.8109 125.256 73.6565 125.06 73.4756C125.256 73.6566 125.475 73.811 125.712 73.935Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M125.035 73.4557C124.943 73.3695 124.857 73.2776 124.776 73.1807C124.857 73.2776 124.943 73.3695 125.035 73.4557Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M177.368 131.605C177.332 131.484 177.289 131.365 177.239 131.25C177.289 131.365 177.332 131.484 177.368 131.605Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M175.852 129.772C175.972 129.835 176.088 129.906 176.199 129.984C176.088 129.906 175.972 129.835 175.852 129.772Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M176.534 130.257C176.721 130.432 176.884 130.63 177.021 130.846C176.884 130.63 176.721 130.432 176.534 130.257Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M176.199 129.99C176.3 130.062 176.396 130.14 176.488 130.224C176.396 130.14 176.3 130.062 176.199 129.99Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M177.211 131.197C177.165 131.103 177.115 131.011 177.06 130.922C177.115 131.011 177.165 131.103 177.211 131.197Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M177.45 131.981C177.433 131.88 177.411 131.78 177.384 131.682C177.411 131.78 177.433 131.88 177.45 131.981Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M269.229 115.295H251.721C252.125 115.015 252.455 114.642 252.683 114.206C252.911 113.771 253.03 113.286 253.03 112.795V104.757C253.03 104.357 252.951 103.961 252.798 103.592C252.645 103.222 252.421 102.887 252.138 102.604C251.856 102.321 251.52 102.097 251.15 101.944C250.781 101.791 250.385 101.712 249.985 101.712H229.839C230.454 101.516 230.991 101.129 231.372 100.607C231.753 100.085 231.959 99.4561 231.959 98.8101V90.7696C231.959 90.278 231.84 89.7938 231.612 89.3584C231.384 88.9229 231.054 88.5492 230.65 88.2692H249.993C250.801 88.2692 251.575 87.9483 252.147 87.3773C252.718 86.8062 253.038 86.0317 253.038 85.2241V77.1836C253.038 76.376 252.718 75.6015 252.147 75.0304C251.575 74.4593 250.801 74.1385 249.993 74.1385H228.463C229.079 73.942 229.616 73.555 229.997 73.0334C230.378 72.5118 230.584 71.8825 230.584 71.2365V63.196C230.584 62.7045 230.465 62.2202 230.237 61.7848C230.009 61.3493 229.679 60.9756 229.275 60.6956H249.996C250.804 60.6956 251.578 60.3748 252.149 59.8037C252.72 59.2326 253.041 58.4581 253.041 57.6505V49.61C253.042 49.2085 252.963 48.8108 252.81 48.4398C252.656 48.0689 252.431 47.7319 252.146 47.4484C251.862 47.1648 251.525 46.9403 251.153 46.7878C250.782 46.6352 250.384 46.5576 249.982 46.5594H239.136C239.752 46.3629 240.289 45.9759 240.67 45.4543C241.051 44.9327 241.257 44.3034 241.257 43.6574V35.6252C241.257 34.8176 240.936 34.043 240.365 33.472C239.794 32.9009 239.019 32.5801 238.212 32.5801H208.803C207.996 32.5801 207.221 32.9009 206.65 33.472C206.079 34.043 205.758 34.8176 205.758 35.6252C205.758 34.8176 205.438 34.043 204.867 33.472C204.295 32.9009 203.521 32.5801 202.713 32.5801H173.302C172.724 32.5822 172.157 32.7492 171.67 33.0615C171.183 33.3738 170.795 33.8184 170.551 34.3433C170.59 34.539 170.609 34.738 170.609 34.9375V42.9834C170.612 43.4248 170.518 43.8613 170.334 44.2625C170.471 44.9565 170.845 45.581 171.393 46.0285H178.947C179.649 46.0282 180.33 46.2723 180.872 46.719H184.173C183.558 46.9155 183.021 47.3025 182.639 47.8241C182.258 48.3457 182.053 48.975 182.052 49.621C182.046 49.4237 182.02 49.2275 181.975 49.0351C181.975 49.0351 181.975 49.0571 181.975 49.0681V57.1058C181.974 57.3621 181.941 57.6172 181.876 57.865C181.926 57.9166 181.97 57.9728 182.008 58.0328C182.025 57.906 182.033 57.7783 182.033 57.6505C182.035 57.8268 182.053 58.0026 182.085 58.1759C182.126 58.2729 182.149 58.3762 182.154 58.4812C182.347 59.1586 182.767 59.7485 183.345 60.1509H180.727L180.793 60.0987C180.55 60.0987 180.303 60.0794 180.061 60.0767C179.974 60.0757 179.888 60.0579 179.808 60.0244C179.524 60.1099 179.229 60.1534 178.933 60.1537L160.885 60.7038C160.481 60.9838 160.151 61.3576 159.923 61.793C159.695 62.2285 159.576 62.7127 159.576 63.2043V71.242C159.576 71.888 159.782 72.5173 160.163 73.0389C160.544 73.5605 161.081 73.9475 161.697 74.144L178.933 74.2871C179.236 74.2873 179.537 74.3327 179.827 74.4219C180.019 74.4383 180.21 74.4714 180.396 74.5209H180.44C180.273 74.4293 180.097 74.3537 179.915 74.2953H184.157C183.541 74.4918 183.004 74.8788 182.623 75.4004C182.242 75.922 182.036 76.5513 182.036 77.1974C182.036 77.0203 182.02 76.8436 181.989 76.6692C181.969 76.6984 181.947 76.726 181.923 76.7517C181.961 76.9456 181.981 77.1428 181.981 77.3404V85.3781C181.981 85.7522 182.036 85.6532 182.036 85.2351C182.036 85.7266 182.155 86.2109 182.383 86.6463C182.611 87.0818 182.941 87.4555 183.345 87.7355L194.098 88.0794C194.467 88.08 194.832 88.1481 195.176 88.2802H197.765C197.301 88.6037 196.937 89.0493 196.711 89.5675C196.994 90.0378 197.143 90.5759 197.143 91.1245V99.1539C197.143 99.5734 197.056 99.9884 196.887 100.372C197.268 101.009 197.867 101.485 198.573 101.712H195.746C195.254 102.032 194.681 102.202 194.095 102.202H183.425C182.997 102.477 182.645 102.856 182.401 103.303C182.157 103.75 182.03 104.251 182.03 104.76C182.03 103.687 181.631 114.267 181.631 114.267C181.631 115.216 198.23 115.642 198.23 115.642C198.651 115.642 199.068 115.73 199.454 115.901C199.627 115.864 199.805 115.849 199.982 115.857H199.965H202.584C202.18 116.137 201.85 116.51 201.622 116.946C201.394 117.381 201.275 117.865 201.275 118.357C201.274 118.211 201.263 118.066 201.242 117.922C201.228 117.955 201.211 117.988 201.195 118.019C201.247 118.242 201.274 118.471 201.275 118.701V126.403C201.275 127.211 201.595 127.985 202.167 128.556C202.738 129.127 203.512 129.448 204.32 129.448H199.643C199.21 129.675 198.727 129.793 198.238 129.792H179.137C178.64 130.048 178.224 130.435 177.933 130.911C177.642 131.388 177.487 131.935 177.486 132.493V140.531C177.486 140.931 177.565 141.327 177.718 141.696C177.871 142.066 178.095 142.401 178.378 142.684C178.661 142.967 178.996 143.191 179.366 143.344C179.735 143.497 180.131 143.576 180.531 143.576H209.948C210.348 143.576 210.744 143.497 211.113 143.344C211.483 143.191 211.818 142.967 212.101 142.684C212.384 142.401 212.608 142.066 212.761 141.696C212.914 141.327 212.993 140.931 212.993 140.531C212.993 140.931 213.072 141.327 213.225 141.696C213.378 142.066 213.602 142.401 213.885 142.684C214.168 142.967 214.503 143.191 214.873 143.344C215.242 143.497 215.638 143.576 216.038 143.576H245.446C245.846 143.576 246.242 143.497 246.612 143.344C246.981 143.191 247.317 142.967 247.6 142.684C247.882 142.401 248.107 142.066 248.26 141.696C248.413 141.327 248.491 140.931 248.491 140.531V132.474C248.491 131.666 248.171 130.892 247.6 130.321C247.028 129.75 246.254 129.429 245.446 129.429H269.227C269.626 129.429 270.022 129.35 270.392 129.197C270.761 129.044 271.097 128.82 271.38 128.537C271.663 128.254 271.887 127.918 272.04 127.549C272.193 127.18 272.272 126.784 272.272 126.384V118.354C272.274 117.953 272.196 117.556 272.044 117.185C271.892 116.814 271.668 116.477 271.386 116.193C271.103 115.909 270.767 115.683 270.397 115.529C270.027 115.375 269.63 115.296 269.229 115.295ZM196.381 60.6956C195.977 60.9756 195.647 61.3493 195.419 61.7848C195.191 62.2202 195.072 62.7045 195.072 63.196C195.072 62.7045 194.953 62.2202 194.725 61.7848C194.496 61.3493 194.166 60.9756 193.762 60.6956H196.381ZM192.951 74.1385C193.566 73.942 194.103 73.555 194.485 73.0334C194.866 72.5118 195.071 71.8825 195.072 71.2365C195.072 71.8825 195.278 72.5118 195.659 73.0334C196.04 73.555 196.577 73.942 197.193 74.1385H192.951ZM203.635 46.5594C204.25 46.3629 204.787 45.9759 205.169 45.4543C205.55 44.9327 205.755 44.3034 205.756 43.6574C205.756 44.3034 205.962 44.9327 206.343 45.4543C206.724 45.9759 207.261 46.3629 207.876 46.5594H203.635ZM212.987 132.468C212.987 132.068 212.909 131.672 212.756 131.303C212.603 130.934 212.378 130.598 212.095 130.315C211.813 130.032 211.477 129.808 211.108 129.655C210.738 129.502 210.342 129.423 209.942 129.423H216.035C215.635 129.424 215.239 129.503 214.869 129.656C214.5 129.81 214.164 130.035 213.882 130.318C213.599 130.601 213.375 130.938 213.223 131.307C213.07 131.677 212.992 132.074 212.993 132.474L212.987 132.468ZM216.214 115.29C216.618 115.01 216.948 114.636 217.176 114.201C217.404 113.765 217.523 113.281 217.523 112.789C217.523 113.281 217.643 113.765 217.871 114.201C218.099 114.636 218.429 115.01 218.833 115.29H216.214ZM217.523 104.749C217.523 104.104 217.318 103.477 216.939 102.956C216.559 102.435 216.024 102.047 215.411 101.85H219.661C219.042 102.045 218.502 102.432 218.119 102.954C217.735 103.477 217.529 104.109 217.529 104.757L217.523 104.749ZM216.214 87.7163C216.618 87.4363 216.948 87.0625 217.176 86.6271C217.404 86.1916 217.523 85.7074 217.523 85.2158C217.523 85.7074 217.643 86.1916 217.871 86.6271C218.099 87.0625 218.429 87.4363 218.833 87.7163H216.214ZM217.523 77.1754C217.523 76.5293 217.318 75.9 216.936 75.3784C216.555 74.8568 216.018 74.4698 215.403 74.2733H219.661C219.042 74.4683 218.501 74.8557 218.118 75.3792C217.735 75.9026 217.528 76.5348 217.529 77.1836L217.523 77.1754ZM216.214 60.1427C216.618 59.8627 216.948 59.4889 217.176 59.0535C217.404 58.618 217.523 58.1338 217.523 57.6422C217.523 58.1338 217.643 58.618 217.871 59.0535C218.099 59.4889 218.429 59.8627 218.833 60.1427H216.214ZM217.523 49.6018C217.523 48.9557 217.318 48.3264 216.936 47.8048C216.555 47.2832 216.018 46.8962 215.403 46.6997H219.661C219.042 46.8947 218.501 47.2821 218.118 47.8056C217.735 48.329 217.528 48.9612 217.529 49.61L217.523 49.6018ZM238.091 115.84C237.687 116.12 237.357 116.494 237.129 116.929C236.901 117.365 236.781 117.849 236.781 118.34C236.781 117.849 236.662 117.365 236.434 116.929C236.206 116.494 235.876 116.12 235.472 115.84H238.091ZM233.734 129.426C234.133 129.426 234.529 129.347 234.899 129.194C235.268 129.041 235.604 128.817 235.887 128.534C236.17 128.251 236.394 127.916 236.547 127.546C236.7 127.177 236.779 126.781 236.779 126.381C236.779 126.781 236.857 127.177 237.01 127.546C237.163 127.916 237.388 128.251 237.671 128.534C237.953 128.817 238.289 129.041 238.658 129.194C239.028 129.347 239.424 129.426 239.824 129.426H233.734Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M177.495 132.474C177.494 132.344 177.484 132.215 177.467 132.086C177.484 132.215 177.494 132.344 177.495 132.474Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M159.573 71.2363C159.573 71.3326 159.573 71.4289 159.56 71.5114C159.568 71.4261 159.573 71.3326 159.573 71.2363Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M124.108 71.6895C124.126 71.8119 124.152 71.9332 124.185 72.0526C124.152 71.9332 124.126 71.8119 124.108 71.6895Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M90.0177 89.6503C89.9674 89.6055 89.9238 89.5536 89.8884 89.4962C89.845 89.4177 89.8161 89.332 89.8032 89.2432C89.7925 89.4521 89.7925 89.6614 89.8032 89.8703C89.895 90.1614 89.9423 90.4646 89.9434 90.7698C89.945 90.4723 89.9904 90.1766 90.0782 89.8923C90.051 89.8237 90.0298 89.7529 90.015 89.6805C90.015 89.6805 90.0177 89.6613 90.0177 89.6503Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M131.711 32.5772H102.303C101.495 32.5772 100.72 32.898 100.149 33.4691C99.5783 34.0401 99.2575 34.8147 99.2575 35.6223C99.2575 34.8147 98.9367 34.0401 98.3656 33.4691C97.7945 32.898 97.02 32.5772 96.2124 32.5772H66.804C65.9964 32.5772 65.2219 32.898 64.6508 33.4691C64.0798 34.0401 63.7589 34.8147 63.7589 35.6223V43.66C63.7596 44.3052 63.9651 44.9336 64.3457 45.4546C64.7264 45.9757 65.2625 46.3624 65.877 46.5593H43.0788C42.6786 46.5596 42.2825 46.6388 41.913 46.7924C41.5435 46.9459 41.2079 47.1708 40.9254 47.4541C40.6428 47.7374 40.4189 48.0736 40.2664 48.4435C40.1138 48.8134 40.0357 49.2097 40.0364 49.6099V57.6476C40.0364 58.1391 40.1556 58.6234 40.3836 59.0588C40.6116 59.4943 40.9418 59.868 41.3458 60.148H20.6188C19.8112 60.148 19.0367 60.4688 18.4656 61.0399C17.8946 61.611 17.5737 62.3855 17.5737 63.1931V71.2308C17.5737 72.0384 17.8946 72.8129 18.4656 73.384C19.0367 73.9551 19.8112 74.2759 20.6188 74.2759H42.1518C41.5364 74.4736 40.9999 74.8619 40.6197 75.3845C40.2394 75.9072 40.0352 76.5371 40.0364 77.1834V85.2212C40.0364 85.7127 40.1556 86.1969 40.3836 86.6324C40.6116 87.0679 40.9418 87.4416 41.3458 87.7216H21.9997C21.1921 87.7216 20.4176 88.0424 19.8465 88.6135C19.2754 89.1845 18.9546 89.9591 18.9546 90.7667V98.8044C18.9546 99.612 19.2754 100.387 19.8465 100.958C20.4176 101.529 21.1921 101.849 21.9997 101.849H42.1518C41.5364 102.047 40.9999 102.435 40.6197 102.958C40.2394 103.481 40.0352 104.111 40.0364 104.757V112.795C40.0364 113.602 40.3572 114.377 40.9283 114.948C41.4994 115.519 42.2739 115.84 43.0815 115.84H60.5901C60.1861 116.12 59.8559 116.494 59.6279 116.929C59.3999 117.364 59.2807 117.849 59.2807 118.34V126.378C59.28 127.185 59.5993 127.959 60.1687 128.53C60.7381 129.101 61.5109 129.424 62.3176 129.426H38.5428C37.7352 129.426 36.9606 129.747 36.3896 130.318C35.8185 130.889 35.4977 131.663 35.4977 132.471V140.509C35.4977 141.316 35.8185 142.091 36.3896 142.662C36.9606 143.233 37.7352 143.554 38.5428 143.554H67.9484C68.756 143.554 69.5305 143.233 70.1016 142.662C70.6726 142.091 70.9934 141.316 70.9934 140.509C70.9934 141.316 71.3143 142.091 71.8853 142.662C72.4564 143.233 73.2309 143.554 74.0385 143.554H103.45C104.257 143.554 105.032 143.233 105.603 142.662C106.174 142.091 106.495 141.316 106.495 140.509V132.474C106.494 131.915 106.339 131.368 106.048 130.892C105.757 130.415 105.341 130.028 104.844 129.772H98.512C98.0226 129.773 97.5402 129.655 97.1064 129.429H91.7314C92.1315 129.429 92.5277 129.35 92.8973 129.197C93.267 129.043 93.6028 128.819 93.8856 128.536C94.1684 128.253 94.3926 127.917 94.5455 127.547C94.6984 127.177 94.7769 126.781 94.7765 126.381C94.7765 127.707 95.4669 118.679 95.4669 118.679C95.4669 117.871 95.7878 117.096 96.3588 116.525C96.9299 115.954 97.7044 115.634 98.512 115.634L109.721 115.29C110.04 115.068 110.313 114.788 110.527 114.464C110.368 114.091 110.286 113.69 110.285 113.284V105.244C110.284 104.648 110.46 104.065 110.789 103.569C110.55 103.005 110.148 102.526 109.633 102.193H93.6762C93.0902 102.193 92.5169 102.023 92.0257 101.704H87.8308C88.4463 101.507 88.9834 101.12 89.3646 100.599C89.7458 100.077 89.9514 99.4477 89.9517 98.8017L89.8444 90.8245C89.8444 90.4641 89.8251 90.1478 89.8114 89.8644C89.6108 89.2155 89.1994 88.6521 88.6423 88.2635H91.261L91.2033 88.3075C92.6887 88.2222 109.653 87.2265 111.033 86.1069C110.999 85.896 110.992 85.6814 111.014 85.4687C110.99 85.3159 110.977 85.1614 110.976 85.0066V76.9826C110.976 76.8836 110.976 76.7846 110.989 76.6883C110.898 76.1346 110.655 75.617 110.288 75.1924C109.921 74.7677 109.444 74.4525 108.91 74.2814H112.618C113.052 74.0548 113.534 73.9368 114.024 73.9376H122.433C122.929 73.6821 123.346 73.295 123.637 72.8185C123.928 72.342 124.082 71.7947 124.083 71.2363V63.1958C124.083 62.7043 123.964 62.2201 123.736 61.7846C123.508 61.3491 123.178 60.9754 122.774 60.6954L114.032 60.1453C112.552 60.1453 111.57 59.5951 112.351 60.1453H109.732C110.133 59.8678 110.461 59.4981 110.689 59.0672C110.917 58.6363 111.038 58.157 111.042 57.6696C111.007 57.4882 110.988 57.3041 110.987 57.1194V49.0652C110.987 49.0652 110.987 49.0652 110.987 49.0459C110.885 48.5064 110.639 48.0043 110.275 47.5928C109.912 47.1813 109.444 46.8755 108.921 46.7078H112.106C112.648 46.2611 113.329 46.017 114.032 46.0174H133.647C133.998 45.7329 134.281 45.3735 134.474 44.9656C134.668 44.5577 134.768 44.1116 134.767 43.66V35.625C134.767 35.224 134.689 34.8268 134.535 34.4563C134.381 34.0858 134.156 33.7493 133.872 33.4661C133.588 33.1829 133.251 32.9586 132.88 32.8061C132.509 32.6535 132.112 32.5757 131.711 32.5772ZM54.3844 60.6954C53.9804 60.9754 53.6502 61.3491 53.4222 61.7846C53.1941 62.2201 53.075 62.7043 53.075 63.1958C53.075 62.7043 52.9559 62.2201 52.7278 61.7846C52.4998 61.3491 52.1697 60.9754 51.7657 60.6954H54.3844ZM53.075 71.2363C53.0753 71.8824 53.2809 72.5116 53.6621 73.0332C54.0433 73.5549 54.5804 73.9419 55.1958 74.1384H50.9542C51.5691 73.9414 52.1056 73.5542 52.4863 73.0326C52.867 72.511 53.0722 71.882 53.0723 71.2363H53.075ZM55.7625 88.269C55.3585 88.549 55.0283 88.9227 54.8003 89.3582C54.5723 89.7936 54.4532 90.2779 54.4531 90.7694C54.4531 90.2779 54.334 89.7936 54.106 89.3582C53.8779 88.9227 53.5478 88.549 53.1438 88.269H55.7625ZM52.3323 101.709C52.9478 101.513 53.4849 101.126 53.8661 100.604C54.2473 100.082 54.4528 99.4532 54.4531 98.8071C54.4534 99.4532 54.659 100.082 55.0402 100.604C55.4214 101.126 55.9585 101.513 56.574 101.709H52.3323ZM89.8829 60.6954C89.4789 60.9754 89.1487 61.3491 88.9207 61.7846C88.6927 62.2201 88.5736 62.7043 88.5735 63.1958C88.5735 62.7043 88.4544 62.2201 88.2264 61.7846C87.9983 61.3491 87.6682 60.9754 87.2642 60.6954H89.8829ZM70.9962 132.474C70.9962 131.666 70.6754 130.892 70.1043 130.32C69.5332 129.749 68.7587 129.429 67.9511 129.429H74.044C73.6439 129.428 73.2477 129.507 72.8779 129.66C72.5081 129.812 72.1721 130.037 71.8891 130.319C71.606 130.602 71.3815 130.938 71.2283 131.308C71.0751 131.677 70.9962 132.074 70.9962 132.474ZM74.2228 115.295C74.6268 115.015 74.957 114.641 75.185 114.206C75.4131 113.771 75.5322 113.286 75.5322 112.795C75.5322 113.286 75.6513 113.771 75.8794 114.206C76.1074 114.641 76.4375 115.015 76.8416 115.295H74.2228ZM75.5212 104.757C75.5228 104.111 75.3194 103.482 74.9402 102.959C74.561 102.437 74.0257 102.048 73.4114 101.849H77.653C77.0346 102.044 76.4945 102.431 76.1111 102.954C75.7277 103.477 75.5211 104.109 75.5212 104.757ZM74.2118 87.7243C74.6158 87.4443 74.946 87.0706 75.174 86.6352C75.4021 86.1997 75.5212 85.7155 75.5212 85.2239C75.5212 85.7155 75.6403 86.1997 75.8684 86.6352C76.0964 87.0706 76.4265 87.4443 76.8306 87.7243H74.2118ZM75.5212 77.1834C75.5209 76.5374 75.3153 75.9081 74.9341 75.3865C74.5529 74.8649 74.0158 74.4779 73.4004 74.2814H77.642C77.0266 74.4779 76.4895 74.8649 76.1083 75.3865C75.7271 75.9081 75.5215 76.5374 75.5212 77.1834ZM74.2118 60.1508C74.6158 59.8708 74.946 59.497 75.174 59.0616C75.4021 58.6261 75.5212 58.1419 75.5212 57.6503C75.5212 58.1419 75.6403 58.6261 75.8684 59.0616C76.0964 59.497 76.4265 59.8708 76.8306 60.1508H74.2118ZM75.5212 49.6099C75.5209 48.9638 75.3153 48.3345 74.9341 47.8129C74.5529 47.2913 74.0158 46.9043 73.4004 46.7078H77.642C77.0266 46.9043 76.4895 47.2913 76.1083 47.8129C75.7271 48.3345 75.5215 48.9638 75.5212 49.6099ZM86.4417 74.1356C87.0572 73.9391 87.5942 73.5521 87.9754 73.0305C88.3567 72.5089 88.5622 71.8796 88.5625 71.2336C88.5628 71.8796 88.7684 72.5089 89.1496 73.0305C89.5308 73.5521 90.0679 73.9391 90.6834 74.1356H86.4417ZM97.1366 46.5593C97.7521 46.3628 98.2892 45.9758 98.6704 45.4542C99.0516 44.9325 99.2572 44.3033 99.2575 43.6572C99.2578 44.3033 99.4634 44.9325 99.8446 45.4542C100.226 45.9758 100.763 46.3628 101.378 46.5593H97.1366Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M125.073 60.9428L125.117 60.9043L125.073 60.9428Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M124.872 61.1387L124.828 61.1882L124.872 61.1387Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M124.617 61.4641L124.64 61.4326L124.617 61.4641Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M124.209 72.1133C124.244 72.2322 124.287 72.3489 124.336 72.4626C124.287 72.3489 124.244 72.2322 124.209 72.1133Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M124.529 72.8369C124.597 72.9461 124.672 73.0508 124.754 73.1505C124.672 73.0509 124.597 72.9461 124.529 72.8369Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M124.347 72.4932C124.4 72.6106 124.461 72.7245 124.528 72.8343C124.461 72.7245 124.4 72.6106 124.347 72.4932Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M124.157 62.5002C124.157 62.4615 124.177 62.4256 124.185 62.3896C124.174 62.4256 124.166 62.4615 124.157 62.5002Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M124.259 62.1566C124.259 62.1262 124.281 62.0958 124.292 62.0654C124.281 62.0958 124.27 62.1262 124.259 62.1566Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M124.094 62.8443C124.094 62.8084 124.094 62.7724 124.111 62.7393C124.105 62.7752 124.1 62.8084 124.094 62.8443Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.1"
              d="M66.5344 46.7109L97.1696 46.7109C98.5126 46.7109 99.6013 45.6222 99.6013 44.2793V35.012C99.6013 33.669 98.5126 32.5803 97.1696 32.5803H66.5344C65.1915 32.5803 64.1028 33.669 64.1028 35.012V44.2793C64.1028 45.6222 65.1915 46.7109 66.5344 46.7109Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M172.689 46.7109L203.324 46.7109C204.667 46.7109 205.756 45.6222 205.756 44.2793V35.012C205.756 33.669 204.667 32.5803 203.324 32.5803H172.689C171.346 32.5803 170.257 33.669 170.257 35.012V44.2793C170.257 45.6222 171.346 46.7109 172.689 46.7109Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M219.909 60.4971L250.544 60.4971C251.887 60.4971 252.975 59.4084 252.975 58.0654V48.7981C252.975 47.4551 251.887 46.3664 250.544 46.3664H219.909C218.566 46.3664 217.477 47.4551 217.477 48.7981V58.0654C217.477 59.4084 218.566 60.4971 219.909 60.4971Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M162.002 74.2812H192.637C193.98 74.2812 195.069 73.1926 195.069 71.8496V62.5823C195.069 61.2393 193.98 60.1506 192.637 60.1506H162.002C160.659 60.1506 159.571 61.2393 159.571 62.5823V71.8496C159.571 73.1926 160.659 74.2812 162.002 74.2812Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M219.909 88.4121H250.544C251.887 88.4121 252.975 87.3234 252.975 85.9804V76.7131C252.975 75.3702 251.887 74.2815 250.544 74.2815H219.909C218.566 74.2815 217.477 75.3702 217.477 76.7131V85.9804C217.477 87.3234 218.566 88.4121 219.909 88.4121Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M219.909 115.986H250.544C251.887 115.986 252.975 114.898 252.975 113.555V104.287C252.975 102.944 251.887 101.856 250.544 101.856H219.909C218.566 101.856 217.477 102.944 217.477 104.287V113.555C217.477 114.898 218.566 115.986 219.909 115.986Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M234.559 115.643H203.495C203.015 115.642 202.548 115.798 202.164 116.085C201.78 116.373 201.5 116.778 201.366 117.238C201.374 117.363 201.366 117.489 201.341 117.612C201.325 117.684 201.304 117.755 201.278 117.824C201.278 117.824 201.278 117.849 201.278 117.86V127.556C201.278 128.144 201.511 128.708 201.927 129.124C202.343 129.54 202.907 129.773 203.495 129.773H234.559C235.147 129.773 235.711 129.54 236.127 129.124C236.543 128.708 236.776 128.144 236.776 127.556V117.86C236.776 117.272 236.543 116.708 236.127 116.292C235.711 115.876 235.147 115.643 234.559 115.643Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M179.926 143.56H210.561C211.904 143.56 212.993 142.471 212.993 141.128V131.861C212.993 130.518 211.904 129.429 210.561 129.429H179.926C178.583 129.429 177.494 130.518 177.494 131.861V141.128C177.494 142.471 178.583 143.56 179.926 143.56Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M77.906 60.4971L108.541 60.4971C109.884 60.4971 110.973 59.4084 110.973 58.0654V48.7981C110.973 47.4551 109.884 46.3664 108.541 46.3664H77.906C76.5631 46.3664 75.4744 47.4551 75.4744 48.7981V58.0654C75.4744 59.4084 76.5631 60.4971 77.906 60.4971Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M55.8477 74.2812H86.4829C87.8259 74.2812 88.9146 73.1926 88.9146 71.8496V62.5823C88.9146 61.2393 87.8259 60.1506 86.4829 60.1506H55.8477C54.5047 60.1506 53.416 61.2393 53.416 62.5823V71.8496C53.416 73.1926 54.5047 74.2812 55.8477 74.2812Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M42.4075 88.4121H73.0427C74.3857 88.4121 75.4744 87.3234 75.4744 85.9804V76.7131C75.4744 75.3702 74.3857 74.2815 73.0427 74.2815H42.4075C41.0645 74.2815 39.9758 75.3702 39.9758 76.7131V85.9804C39.9758 87.3234 41.0645 88.4121 42.4075 88.4121Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M56.8821 102.199H87.5173C88.8603 102.199 89.949 101.111 89.949 99.7676V90.5002C89.949 89.1573 88.8603 88.0686 87.5173 88.0686H56.8821C55.5392 88.0686 54.4505 89.1573 54.4505 90.5002V99.7676C54.4505 101.111 55.5392 102.199 56.8821 102.199Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M42.4075 115.986H73.0427C74.3857 115.986 75.4744 114.898 75.4744 113.555V104.287C75.4744 102.944 74.3857 101.856 73.0427 101.856H42.4075C41.0645 101.856 39.9758 102.944 39.9758 104.287V113.555C39.9758 114.898 41.0645 115.986 42.4075 115.986Z"
              fill="black"
            />
            <path
              opacity="0.45"
              d="M26.3487 129.786H56.9839C58.3268 129.786 59.4155 128.697 59.4155 127.354V118.087C59.4155 116.744 58.3268 115.656 56.9839 115.656H26.3487C25.0057 115.656 23.917 116.744 23.917 118.087V127.354C23.917 128.697 25.0057 129.786 26.3487 129.786Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M233.621 102.186H264.256C265.599 102.186 266.688 101.097 266.688 99.7539V90.4866C266.688 89.1436 265.599 88.0549 264.256 88.0549H233.621C232.278 88.0549 231.189 89.1436 231.189 90.4866V99.7539C231.189 101.097 232.278 102.186 233.621 102.186Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M232.116 74.3311H262.751C264.094 74.3311 265.183 73.2424 265.183 71.8994V62.6321C265.183 61.2891 264.094 60.2004 262.751 60.2004H232.116C230.773 60.2004 229.685 61.2891 229.685 62.6321V71.8994C229.685 73.2424 230.773 74.3311 232.116 74.3311Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M249.933 143.339H280.568C281.911 143.339 283 142.25 283 140.907V131.64C283 130.297 281.911 129.208 280.568 129.208H249.933C248.59 129.208 247.501 130.297 247.501 131.64V140.907C247.501 142.25 248.59 143.339 249.933 143.339Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M2.51054 143.589H33.1457C34.4887 143.589 35.5774 142.5 35.5774 141.157V131.89C35.5774 130.547 34.4887 129.458 33.1457 129.458H2.51054C1.16756 129.458 0.0788727 130.547 0.0788727 131.89V141.157C0.0788727 142.5 1.16756 143.589 2.51054 143.589Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M7.27494 115.732H37.9101C39.2531 115.732 40.3418 114.644 40.3418 113.301V104.033C40.3418 102.69 39.2531 101.602 37.9101 101.602H7.27494C5.93196 101.602 4.84327 102.69 4.84327 104.033V113.301C4.84327 114.644 5.93196 115.732 7.27494 115.732Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M7.27494 88.3818H37.9101C39.2531 88.3818 40.3418 87.2931 40.3418 85.9502V76.6829C40.3418 75.3399 39.2531 74.2512 37.9101 74.2512H7.27494C5.93196 74.2512 4.84327 75.3399 4.84327 76.6829V85.9502C4.84327 87.2931 5.93196 88.3818 7.27494 88.3818Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.45"
              d="M8.53202 60.5273L39.1672 60.5273C40.5102 60.5273 41.5989 59.4386 41.5989 58.0957V48.8284C41.5989 47.4854 40.5102 46.3967 39.1672 46.3967H8.53202C7.18905 46.3967 6.10036 47.4854 6.10036 48.8284V58.0957C6.10036 59.4386 7.18905 60.5273 8.53202 60.5273Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.1"
              d="M8.53202 60.5273L39.1672 60.5273C40.5102 60.5273 41.5989 59.4386 41.5989 58.0957V48.8284C41.5989 47.4854 40.5102 46.3967 39.1672 46.3967H8.53202C7.18905 46.3967 6.10036 47.4854 6.10036 48.8284V58.0957C6.10036 59.4386 7.18905 60.5273 8.53202 60.5273Z"
              fill="black"
            />
            <path
              opacity="0.45"
              d="M31.1155 46.7266L61.7507 46.7266C63.0937 46.7266 64.1824 45.6379 64.1824 44.2949V35.0276C64.1824 33.6846 63.0937 32.5959 61.7507 32.5959H31.1155C29.7725 32.5959 28.6838 33.6846 28.6838 35.0276V44.2949C28.6838 45.6379 29.7725 46.7266 31.1155 46.7266Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.1"
              d="M62.0535 129.77H92.6887C94.0317 129.77 95.1204 128.681 95.1204 127.338V118.071C95.1204 116.728 94.0317 115.639 92.6887 115.639H62.0535C60.7105 115.639 59.6218 116.728 59.6218 118.071V127.338C59.6218 128.681 60.7105 129.77 62.0535 129.77Z"
              fill="black"
            />
            <path
              opacity="0.1"
              d="M37.9292 143.56H68.5644C69.9074 143.56 70.9961 142.471 70.9961 141.128V131.861C70.9961 130.518 69.9074 129.429 68.5644 129.429H37.9292C36.5863 129.429 35.4976 130.518 35.4976 131.861V141.128C35.4976 142.471 36.5863 143.56 37.9292 143.56Z"
              fill="black"
            />
          </g>
          <SunGroup>
            <path
              opacity="0.5"
              d="M222.981 15.9104C227.375 15.9104 230.936 12.3487 230.936 7.95519C230.936 3.56166 227.375 0 222.981 0C218.588 0 215.026 3.56166 215.026 7.95519C215.026 12.3487 218.588 15.9104 222.981 15.9104Z"
              fill="#2C98F0"
            />
          </SunGroup>
          <CloudGroup>
            <Cloud
              duration={5}
              opacity="0.5"
              d="M69.3789 22.3779H67.4863C67.8272 22.3624 68.1489 22.216 68.3846 21.9693C68.6203 21.7226 68.7518 21.3946 68.7518 21.0534C68.7518 20.7122 68.6203 20.3842 68.3846 20.1375C68.1489 19.8908 67.8272 19.7445 67.4863 19.7289H52.1564C51.9774 19.7208 51.7986 19.749 51.6307 19.8118C51.4629 19.8747 51.3096 19.971 51.1801 20.0948C51.0505 20.2186 50.9474 20.3673 50.8769 20.5321C50.8065 20.6969 50.7701 20.8742 50.7701 21.0534C50.7701 21.2326 50.8065 21.4099 50.8769 21.5747C50.9474 21.7395 51.0505 21.8882 51.1801 22.012C51.3096 22.1358 51.4629 22.2321 51.6307 22.295C51.7986 22.3578 51.9774 22.3861 52.1564 22.3779H54.0489C53.7081 22.3934 53.3863 22.5398 53.1506 22.7865C52.9149 23.0331 52.7834 23.3612 52.7834 23.7024C52.7834 24.0436 52.9149 24.3716 53.1506 24.6183C53.3863 24.865 53.7081 25.0113 54.0489 25.0269H51.3999C51.2209 25.0187 51.0421 25.0469 50.8743 25.1098C50.7065 25.1727 50.5532 25.2689 50.4236 25.3927C50.294 25.5165 50.1909 25.6653 50.1205 25.8301C50.05 25.9948 50.0137 26.1722 50.0137 26.3514C50.0137 26.5306 50.05 26.7079 50.1205 26.8727C50.1909 27.0374 50.294 27.1862 50.4236 27.31C50.5532 27.4338 50.7065 27.53 50.8743 27.5929C51.0421 27.6558 51.2209 27.684 51.3999 27.6759H66.7189C67.0597 27.6603 67.3814 27.514 67.6171 27.2673C67.8528 27.0206 67.9844 26.6926 67.9844 26.3514C67.9844 26.0102 67.8528 25.6821 67.6171 25.4354C67.3814 25.1887 67.0597 25.0424 66.7189 25.0269H69.3679C69.7087 25.0113 70.0304 24.865 70.2661 24.6183C70.5018 24.3716 70.6334 24.0436 70.6334 23.7024C70.6334 23.3612 70.5018 23.0331 70.2661 22.7865C70.0304 22.5398 69.7087 22.3934 69.3679 22.3779H69.3789Z"
              fill="#DEE3F3"
            />
            <Cloud
              duration={3.5}
              opacity="0.5"
              d="M221.972 6.99775H220.53C220.788 6.98426 221.032 6.87215 221.21 6.68457C221.388 6.49698 221.487 6.24822 221.487 5.9896C221.487 5.73097 221.388 5.48221 221.21 5.29463C221.032 5.10704 220.788 4.99494 220.53 4.98145H208.864C208.606 4.99494 208.363 5.10704 208.185 5.29463C208.007 5.48221 207.907 5.73097 207.907 5.9896C207.907 6.24822 208.007 6.49698 208.185 6.68457C208.363 6.87215 208.606 6.98426 208.864 6.99775H210.308C210.172 6.9906 210.035 7.01138 209.906 7.05881C209.778 7.10625 209.66 7.17935 209.561 7.27367C209.461 7.36799 209.382 7.48155 209.328 7.60744C209.274 7.73332 209.246 7.86889 209.246 8.0059C209.246 8.14291 209.274 8.27849 209.328 8.40437C209.382 8.53026 209.461 8.64382 209.561 8.73814C209.66 8.83245 209.778 8.90556 209.906 8.95299C210.035 9.00043 210.172 9.02121 210.308 9.01406H208.292C208.034 9.02755 207.791 9.13965 207.612 9.32724C207.434 9.51483 207.335 9.76359 207.335 10.0222C207.335 10.2808 207.434 10.5296 207.612 10.7172C207.791 10.9048 208.034 11.0169 208.292 11.0304H219.961C220.098 11.0375 220.234 11.0167 220.363 10.9693C220.492 10.9219 220.609 10.8488 220.708 10.7544C220.808 10.6601 220.887 10.5466 220.941 10.4207C220.995 10.2948 221.023 10.1592 221.023 10.0222C221.023 9.8852 220.995 9.74962 220.941 9.62374C220.887 9.49785 220.808 9.38429 220.708 9.28998C220.609 9.19566 220.492 9.12256 220.363 9.07512C220.234 9.02768 220.098 9.00691 219.961 9.01406H221.977C222.114 9.02121 222.251 9.00043 222.379 8.95299C222.508 8.90556 222.625 8.83245 222.725 8.73814C222.824 8.64382 222.903 8.53026 222.957 8.40437C223.011 8.27849 223.039 8.14291 223.039 8.0059C223.039 7.86889 223.011 7.73332 222.957 7.60744C222.903 7.48155 222.824 7.36799 222.725 7.27367C222.625 7.17935 222.508 7.10625 222.379 7.05881C222.251 7.01138 222.114 6.9906 221.977 6.99775H221.972Z"
              fill="#DEE3F3"
            />
            <Cloud
              duration={6}
              opacity="0.5"
              d="M105.689 3.67281H103.796C103.975 3.68097 104.154 3.65276 104.322 3.58988C104.49 3.527 104.643 3.43076 104.772 3.30696C104.902 3.18317 105.005 3.0344 105.076 2.86963C105.146 2.70486 105.182 2.52752 105.182 2.34833C105.182 2.16913 105.146 1.99179 105.076 1.82702C105.005 1.66226 104.902 1.51348 104.772 1.38969C104.643 1.2659 104.49 1.16965 104.322 1.10677C104.154 1.04389 103.975 1.01568 103.796 1.02384H88.4662C88.2872 1.01568 88.1084 1.04389 87.9406 1.10677C87.7728 1.16965 87.6194 1.2659 87.4899 1.38969C87.3603 1.51348 87.2572 1.66226 87.1867 1.82702C87.1163 1.99179 87.0799 2.16913 87.0799 2.34833C87.0799 2.52752 87.1163 2.70486 87.1867 2.86963C87.2572 3.0344 87.3603 3.18317 87.4899 3.30696C87.6194 3.43076 87.7728 3.527 87.9406 3.58988C88.1084 3.65276 88.2872 3.68097 88.4662 3.67281H90.3587C90.0179 3.68835 89.6961 3.83468 89.4604 4.08137C89.2247 4.32806 89.0932 4.65612 89.0932 4.9973C89.0932 5.33849 89.2247 5.66655 89.4604 5.91324C89.6961 6.15993 90.0179 6.30626 90.3587 6.32179H87.7097C87.5307 6.31363 87.3519 6.34185 87.1841 6.40473C87.0163 6.46761 86.863 6.56385 86.7334 6.68765C86.6039 6.81144 86.5007 6.96022 86.4303 7.12498C86.3598 7.28975 86.3235 7.46709 86.3235 7.64628C86.3235 7.82548 86.3598 8.00282 86.4303 8.16759C86.5007 8.33235 86.6039 8.48113 86.7334 8.60492C86.863 8.72871 87.0163 8.82496 87.1841 8.88784C87.3519 8.95072 87.5307 8.97893 87.7097 8.97077H103.029C103.37 8.95524 103.691 8.8089 103.927 8.56222C104.163 8.31553 104.294 7.98747 104.294 7.64628C104.294 7.3051 104.163 6.97704 103.927 6.73035C103.691 6.48366 103.37 6.33733 103.029 6.32179H105.678C106.019 6.30626 106.34 6.15993 106.576 5.91324C106.812 5.66655 106.943 5.33849 106.943 4.9973C106.943 4.65612 106.812 4.32806 106.576 4.08137C106.34 3.83468 106.019 3.68835 105.678 3.67281H105.689Z"
              fill="#DEE3F3"
            />
          </CloudGroup>

          <RedPlant>
            <path
              d="M41.7584 129.357C41.7584 129.357 52.3213 150.093 43.7141 161.437C35.107 172.781 44.4954 203.688 44.4954 203.688"
              stroke="#FC6681"
              strokeWidth="2"
              strokeMiterlimit="10"
            />
            <path
              d="M44.8859 122.888C44.8859 126.882 41.9619 130.128 41.9619 130.128C41.9619 130.128 39.0186 126.882 39.0186 122.888C39.0186 118.894 41.9619 115.65 41.9619 115.65C41.9619 115.65 44.8859 118.905 44.8859 122.888Z"
              fill="#FC6681"
            />

            <path
              d="M51.5374 129.357C51.5374 129.357 62.1003 150.093 53.4932 161.437C44.8861 172.781 54.2744 203.688 54.2744 203.688"
              stroke="#FC6681"
              strokeWidth="2"
              strokeMiterlimit="10"
            />
            <path
              d="M54.6677 122.888C54.6677 126.884 51.7326 130.125 51.7326 130.125C51.7326 130.125 48.8003 126.882 48.8003 122.888C48.8003 118.894 51.7354 115.65 51.7354 115.65C51.7354 115.65 54.6677 118.905 54.6677 122.888Z"
              fill="#FC6681"
            />
            <path
              d="M53.0226 139.502C50.2526 142.382 45.8899 142.685 45.8899 142.685C45.8899 142.685 46.0219 138.316 48.7919 135.434C51.562 132.551 55.9247 132.251 55.9247 132.251C55.9247 132.251 55.7926 136.622 53.0226 139.502Z"
              fill="#FC6681"
            />
            <path
              d="M53.2978 153.806C50.5277 156.686 46.165 156.988 46.165 156.988C46.165 156.988 46.2971 152.62 49.0671 149.737C51.8371 146.855 56.1998 146.555 56.1998 146.555C56.1998 146.555 56.0678 150.926 53.2978 153.806Z"
              fill="#FC6681"
            />
            <path
              d="M38.2704 161.676C40.8918 164.702 40.7983 169.064 40.7983 169.064C40.7983 169.064 36.4576 168.542 33.8389 165.524C31.2202 162.507 31.3109 158.136 31.3109 158.136C31.3109 158.136 35.6489 158.658 38.2704 161.676Z"
              fill="#FC6681"
            />
            <path
              d="M40.7022 131.17C44.0333 133.37 45.1034 137.615 45.1034 137.615C45.1034 137.615 40.7819 138.269 37.4508 136.063C34.1196 133.857 33.0496 129.618 33.0496 129.618C33.0496 129.618 37.3682 128.963 40.7022 131.17Z"
              fill="#FC6681"
            />

            <path
              d="M47.1886 149.21C47.1886 149.21 40.826 139.189 31.9026 138.985"
              stroke="#FC6681"
              strokeWidth="2"
              strokeMiterlimit="10"
            />

            <path
              d="M32.0565 140.683C32.968 140.683 33.7069 139.944 33.7069 139.032C33.7069 138.121 32.968 137.382 32.0565 137.382C31.1449 137.382 30.406 138.121 30.406 139.032C30.406 139.944 31.1449 140.683 32.0565 140.683Z"
              fill="#FC6681"
            />
            <path
              d="M51.0394 166.814C51.0394 166.814 44.6769 156.793 35.7534 156.59"
              stroke="#FC6681"
              strokeWidth="2"
              strokeMiterlimit="10"
            />
            <path
              d="M35.9075 158.287C36.819 158.287 37.558 157.548 37.558 156.637C37.558 155.725 36.819 154.986 35.9075 154.986C34.996 154.986 34.2571 155.725 34.2571 156.637C34.2571 157.548 34.996 158.287 35.9075 158.287Z"
              fill="#FC6681"
            />
          </RedPlant>
          <YellowPlant>
            <path
              d="M57.0142 129.357C57.0142 129.357 46.4513 150.093 55.0584 161.437C63.6655 172.781 54.2772 203.688 54.2772 203.688"
              stroke="#FFD037"
              strokeWidth="2"
              strokeMiterlimit="10"
            />
            <path
              d="M47.2351 129.357C47.2351 129.357 36.6722 150.093 45.2794 161.437C53.8865 172.781 44.4981 203.688 44.4981 203.688"
              stroke="#FFD037"
              strokeWidth="2"
              strokeMiterlimit="10"
            />
            <path
              d="M44.1047 122.888C44.1047 126.884 47.0398 130.125 47.0398 130.125C47.0398 130.125 49.9749 126.884 49.9749 122.888C49.9749 118.891 47.0398 115.65 47.0398 115.65C47.0398 115.65 44.1047 118.905 44.1047 122.888Z"
              fill="#FFD037"
            />
            <path
              d="M53.8865 122.888C53.8865 126.882 56.816 130.128 56.816 130.128C56.816 130.128 59.7511 126.887 59.7511 122.89C59.7511 118.894 56.816 115.65 56.816 115.65C56.816 115.65 53.8865 118.905 53.8865 122.888Z"
              fill="#FFD037"
            />
            <path
              d="M54.7281 139.81C51.9223 142.657 51.738 147.026 51.738 147.026C51.738 147.026 56.1035 146.778 58.9093 143.931C61.715 141.084 61.8993 136.716 61.8993 136.716C61.8993 136.716 57.5339 136.963 54.7281 139.81Z"
              fill="#FFD037"
            />
            <path
              d="M60.2296 159.616C57.4238 162.463 57.2395 166.831 57.2395 166.831C57.2395 166.831 61.6049 166.584 64.4107 163.737C67.2165 160.89 67.4008 156.521 67.4008 156.521C67.4008 156.521 63.0353 156.769 60.2296 159.616Z"
              fill="#FFD037"
            />
            <path
              d="M52.1396 155.261C52.1396 155.261 58.4994 145.237 67.4229 145.022"
              stroke="#FFD037"
              strokeWidth="2"
              strokeMiterlimit="10"
            />

            <path
              d="M46.3633 163.514C46.3633 163.514 52.723 153.49 61.6465 153.275"
              stroke="#FFD037"
              strokeWidth="2"
              strokeMiterlimit="10"
            />
            <path
              d="M67.1287 146.597C68.0402 146.597 68.7792 145.858 68.7792 144.946C68.7792 144.035 68.0402 143.296 67.1287 143.296C66.2172 143.296 65.4783 144.035 65.4783 144.946C65.4783 145.858 66.2172 146.597 67.1287 146.597Z"
              fill="#FFD037"
            />

            <path
              d="M61.7647 154.986C62.6762 154.986 63.4152 154.248 63.4152 153.336C63.4152 152.424 62.6762 151.686 61.7647 151.686C60.8532 151.686 60.1143 152.424 60.1143 153.336C60.1143 154.248 60.8532 154.986 61.7647 154.986Z"
              fill="#FFD037"
            />
          </YellowPlant>
          <path
            d="M86.1831 191.637C86.1831 191.637 70.8613 188.573 66.7737 184.485C62.6861 180.398 44.3 173.248 42.2562 178.357C40.2124 183.465 14.6771 200.83 32.0426 203.903C49.4082 206.975 72.9024 207.988 78.0106 205.947C83.1187 203.906 86.1831 191.637 86.1831 191.637Z"
            fill="#A8A8A8"
          />
          <path
            opacity="0.2"
            d="M32.0427 201.996C49.4082 205.06 72.9024 206.081 78.0106 204.04C81.9001 202.483 84.6124 195.009 85.6714 191.529L86.1831 191.637C86.1831 191.637 83.1187 203.894 78.0106 205.941C72.9024 207.987 49.4027 206.961 32.0427 203.897C27.0308 203.011 25.5976 200.934 26.1368 198.304C26.5576 200.018 28.3126 201.339 32.0427 201.996Z"
            fill="black"
          />
          <path
            d="M251.674 133.005C251.674 133.005 255.347 137.805 249.98 145.056C244.613 152.307 240.19 158.425 241.978 162.936C241.978 162.936 250.073 149.474 256.664 149.287C263.255 149.1 258.925 141.1 251.674 133.005Z"
            fill="#FC6681"
          />
          <path
            opacity="0.1"
            d="M251.674 133.005C251.995 133.468 252.247 133.975 252.425 134.51C258.854 142.063 262.281 149.113 256.1 149.289C250.343 149.454 243.447 159.742 241.796 162.347C241.85 162.548 241.916 162.745 241.992 162.939C241.992 162.939 250.087 149.476 256.678 149.289C263.269 149.102 258.925 141.1 251.674 133.005Z"
            fill="black"
          />
          <path
            d="M258.502 139.123C258.502 140.812 258.312 142.182 258.078 142.182C257.844 142.182 257.654 140.806 257.654 139.123C257.654 137.439 257.891 138.229 258.125 138.229C258.359 138.229 258.502 137.434 258.502 139.123Z"
            fill="#FFD037"
          />
          <path
            d="M260.843 141.141C259.36 141.949 258.064 142.439 257.954 142.241C257.844 142.043 258.956 141.212 260.43 140.404C261.904 139.595 261.329 140.183 261.439 140.39C261.549 140.596 262.325 140.332 260.843 141.141Z"
            fill="#FFD037"
          />
          <path
            d="M232.284 133.005C232.284 133.005 228.612 137.805 233.979 145.056C239.345 152.307 243.769 158.425 241.981 162.936C241.981 162.936 233.885 149.474 227.294 149.287C220.703 149.1 225.033 141.1 232.284 133.005Z"
            fill="#FC6681"
          />
          <path
            opacity="0.1"
            d="M232.284 133.005C231.964 133.468 231.711 133.975 231.533 134.51C225.105 142.063 221.677 149.113 227.858 149.289C233.615 149.454 240.512 159.742 242.162 162.347C242.108 162.548 242.043 162.745 241.967 162.939C241.967 162.939 233.871 149.476 227.28 149.289C220.69 149.102 225.033 141.1 232.284 133.005Z"
            fill="black"
          />
          <path
            d="M225.457 139.123C225.457 140.812 225.647 142.182 225.88 142.182C226.114 142.182 226.304 140.806 226.304 139.123C226.304 137.439 226.067 138.229 225.834 138.229C225.6 138.229 225.457 137.434 225.457 139.123Z"
            fill="#FFD037"
          />
          <path
            d="M223.116 141.141C224.598 141.949 225.894 142.439 226.004 142.241C226.114 142.043 225.003 141.212 223.528 140.404C222.054 139.595 222.629 140.183 222.519 140.39C222.409 140.596 221.633 140.332 223.116 141.141Z"
            fill="#FFD037"
          />
          <path
            d="M226.626 162.311C226.626 162.311 236.892 161.995 239.983 159.792C243.075 157.588 255.773 154.958 256.54 158.49C257.308 162.022 271.966 176.062 260.378 176.156C248.789 176.249 233.45 174.351 230.361 172.47C227.272 170.588 226.626 162.311 226.626 162.311Z"
            fill="#A8A8A8"
          />
          <path
            opacity="0.2"
            d="M260.587 174.929C248.998 175.023 233.659 173.125 230.57 171.243C228.218 169.81 227.269 164.672 226.97 162.301H226.626C226.626 162.301 227.275 170.581 230.364 172.459C233.453 174.338 248.794 176.239 260.38 176.145C263.725 176.118 264.881 174.929 264.817 173.166C264.352 174.245 263.076 174.907 260.587 174.929Z"
            fill="black"
          />
        </World>

        <Robot state={state}>
          <path
            d="M152.099 148.557H157.326V145.32V144.756H114.552V145.32V148.557H119.778V152.362H111.223V157.112H160.654V152.362H152.099V148.557Z"
            fill="url(#paint0_linear)"
          />
          <path
            d="M187.117 152.04C187.491 146.923 187.359 142.519 186.842 138.726C186.256 134.361 185.169 130.809 183.791 127.921C181.04 122.145 177.12 119.011 173.679 117.309C171.375 116.14 168.858 115.453 166.28 115.29C166.167 114.499 165.773 113.775 165.17 113.252C164.567 112.728 163.796 112.438 162.997 112.437C162.198 112.435 161.426 112.721 160.821 113.242C160.216 113.764 159.819 114.486 159.703 115.276V106.732H141.641V101.979H165.98C166.709 101.979 167.409 101.689 167.925 101.173C168.441 100.657 168.731 99.9575 168.731 99.228V74.3144C168.731 73.5848 168.441 72.8852 167.925 72.3693C167.409 71.8534 166.709 71.5636 165.98 71.5636H156.74V47.0049C157.39 46.7112 157.941 46.2364 158.328 45.6373C158.715 45.0381 158.921 44.3401 158.921 43.6269C158.921 43.5912 158.921 43.5554 158.921 43.5169C158.921 43.4784 158.921 43.4454 158.921 43.4069C158.921 42.422 158.53 41.4774 157.834 40.781C157.137 40.0846 156.193 39.6934 155.208 39.6934C154.223 39.6934 153.278 40.0846 152.582 40.781C151.886 41.4774 151.494 42.422 151.494 43.4069C151.494 43.4426 151.494 43.4784 151.494 43.5169C151.494 43.5554 151.494 43.5884 151.494 43.6269C151.494 44.2994 151.677 44.9592 152.023 45.5358C152.369 46.1124 152.865 46.5841 153.458 46.9003V71.5609H119.206V46.9003C119.799 46.5841 120.296 46.1124 120.642 45.5358C120.988 44.9592 121.17 44.2994 121.17 43.6269C121.17 43.5912 121.17 43.5554 121.17 43.5169C121.17 43.4784 121.17 43.4454 121.17 43.4069C121.17 42.422 120.779 41.4774 120.082 40.781C119.386 40.0846 118.441 39.6934 117.456 39.6934C116.472 39.6934 115.527 40.0846 114.831 40.781C114.134 41.4774 113.743 42.422 113.743 43.4069C113.743 43.4426 113.743 43.4784 113.743 43.5169C113.743 43.5554 113.743 43.5884 113.743 43.6269C113.743 44.3401 113.949 45.0381 114.336 45.6373C114.723 46.2364 115.274 46.7112 115.924 47.0049V71.5581H105.898C105.168 71.5581 104.469 71.8479 103.953 72.3638C103.437 72.8797 103.147 73.5793 103.147 74.3089V99.2197C103.147 99.9493 103.437 100.649 103.953 101.165C104.469 101.681 105.168 101.971 105.898 101.971H130.236V106.724H112.175V113.727C112.023 113.282 111.778 112.874 111.457 112.531L111.377 112.451C110.912 111.986 110.32 111.669 109.674 111.54C109.029 111.412 108.36 111.478 107.753 111.73C107.145 111.981 106.625 112.408 106.26 112.955C105.895 113.502 105.7 114.145 105.7 114.803V115.279C105.7 115.279 102.283 115.279 98.1984 117.3C94.7572 119.003 90.8401 122.136 88.0866 127.913C86.7112 130.801 85.6109 134.355 85.036 138.718C84.5244 142.508 84.3896 146.915 84.7609 152.032C77.1331 158.358 86.6865 167.562 86.6865 167.562C94.5124 167.562 94.3391 154.57 94.2511 152.353H94.2896C94.2896 152.353 94.2676 152.243 94.2346 152.04C93.664 148.411 93.5062 144.729 93.7642 141.064C93.9815 138.267 94.5179 135.307 95.6182 132.644C96.4407 130.546 97.7271 128.66 99.3812 127.129C101.167 125.547 103.357 124.492 105.708 124.084V126.221C105.708 127.009 105.988 127.771 106.497 128.371C107.006 128.972 107.712 129.373 108.488 129.502C109.265 129.631 110.063 129.48 110.739 129.076C111.415 128.672 111.926 128.042 112.18 127.297V144.761H159.694V127.654C159.791 128.316 160.085 128.934 160.539 129.426L160.63 129.522C161.095 129.992 161.69 130.312 162.338 130.443C162.987 130.573 163.659 130.507 164.27 130.253C164.88 129.999 165.401 129.569 165.766 129.017C166.131 128.465 166.323 127.818 166.318 127.156V124.109C168.615 124.536 170.751 125.582 172.496 127.134C174.15 128.666 175.437 130.551 176.259 132.65C177.36 135.315 177.893 138.272 178.113 141.07C178.371 144.734 178.214 148.416 177.643 152.045C177.61 152.249 177.588 152.359 177.588 152.359H177.627C177.538 154.576 177.365 167.568 185.191 167.568C185.191 167.571 194.744 158.372 187.117 152.04Z"
            fill="url(#paint1_linear)"
          />
          <path
            d="M113.6 157.55V161.869H119.305V168.52V174.225V182.78V187.533V190.386H112.648V197.037H130.71V190.386H127.86V187.533V182.78V174.225V168.52V161.869H134.511V157.55V157.115H113.6V157.55Z"
            fill="url(#paint2_linear)"
          />
          <path
            d="M136.415 157.55V161.869H144.97V168.52V174.225V182.78V187.533V190.386H138.316V197.037H156.377V190.386H153.525V187.533V182.78V174.225V168.52V161.869H157.326V157.55V157.115H136.415V157.55Z"
            fill="url(#paint3_linear)"
          />
          <Head state={state}>
            <path
              d="M164.283 72.8232H107.598C105.627 72.8232 104.03 74.4206 104.03 76.391V98.8537C104.03 100.824 105.627 102.421 107.598 102.421H164.283C166.253 102.421 167.85 100.824 167.85 98.8537V76.391C167.85 74.4206 166.253 72.8232 164.283 72.8232Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.1"
              d="M162.761 97.8799H109.116V98.4355H162.761V97.8799Z"
              fill="black"
            />
            <path
              opacity="0.3"
              d="M162.761 77.4482H109.116V97.7956H162.761V77.4482Z"
              fill="black"
            />

            <Eye state={state}>
              <path
                d="M121.602 95.0227C125.689 95.0227 129.001 91.7098 129.001 87.6232C129.001 83.5365 125.689 80.2236 121.602 80.2236C117.515 80.2236 114.202 83.5365 114.202 87.6232C114.202 91.7098 117.515 95.0227 121.602 95.0227Z"
                fill="#DEE3F3"
              />
            </Eye>
            <Eye state={state}>
              <path
                d="M150.276 95.0227C154.362 95.0227 157.675 91.7098 157.675 87.6232C157.675 83.5365 154.362 80.2236 150.276 80.2236C146.189 80.2236 142.876 83.5365 142.876 87.6232C142.876 91.7098 146.189 95.0227 150.276 95.0227Z"
                fill="#DEE3F3"
              />
            </Eye>
            <path d="M119.657 45.4346H116.472V72.8266H119.657V45.4346Z" fill="#2C98F0" />
            <path d="M156.179 45.4346H152.994V72.8266H156.179V45.4346Z" fill="#2C98F0" />
            <path
              opacity="0.1"
              d="M117.96 49.2551C119.953 49.2551 121.569 47.6393 121.569 45.6461C121.569 43.6529 119.953 42.0371 117.96 42.0371C115.967 42.0371 114.351 43.6529 114.351 45.6461C114.351 47.6393 115.967 49.2551 117.96 49.2551Z"
              fill="black"
            />
            <path
              d="M117.96 49.0432C119.953 49.0432 121.569 47.4274 121.569 45.4342C121.569 43.441 119.953 41.8252 117.96 41.8252C115.967 41.8252 114.351 43.441 114.351 45.4342C114.351 47.4274 115.967 49.0432 117.96 49.0432Z"
              fill="#2C98F0"
            />
            <path
              opacity="0.1"
              d="M154.693 49.2551C156.687 49.2551 158.302 47.6393 158.302 45.6461C158.302 43.6529 156.687 42.0371 154.693 42.0371C152.7 42.0371 151.084 43.6529 151.084 45.6461C151.084 47.6393 152.7 49.2551 154.693 49.2551Z"
              fill="black"
            />
            <path
              d="M154.693 49.0432C156.687 49.0432 158.302 47.4274 158.302 45.4342C158.302 43.441 156.687 41.8252 154.693 41.8252C152.7 41.8252 151.084 43.441 151.084 45.4342C151.084 47.4274 152.7 49.0432 154.693 49.0432Z"
              fill="#2C98F0"
            />
          </Head>
          <path d="M141.487 102.422H130.388V108.897H141.487V102.422Z" fill="#2C98F0" />
          <path d="M159.062 107.045H112.816V144.043H159.062V107.045Z" fill="#2C98F0" />
          <path
            d="M156.751 144.043V147.743H151.662V151.442H120.213V147.743H115.129V144.043H156.751Z"
            fill="#2C98F0"
          />
          <path
            opacity="0.3"
            d="M156.751 144.043V147.743H151.662V151.442H120.213V147.743H115.129V144.043H156.751Z"
            fill="black"
          />
          <path d="M159.989 151.443H111.892V156.067H159.989V151.443Z" fill="#2C98F0" />
          <path d="M134.55 156.069H114.202V160.693H134.55V156.069Z" fill="#2C98F0" />
          <path d="M156.748 156.069H136.401V160.693H156.748V156.069Z" fill="#2C98F0" />
          <path d="M130.853 188.44H113.278V194.916H130.853V188.44Z" fill="#2C98F0" />
          <path
            d="M119.753 167.167V172.718V181.042V185.666V188.441H128.077V185.666V181.042V172.718V167.167V160.691H119.753V167.167Z"
            fill="#2C98F0"
          />
          <path
            d="M144.725 160.691V167.167V172.718V181.042V185.666V188.441H153.051V185.666V181.042V172.718V167.167V160.691H144.725Z"
            fill="#2C98F0"
          />
          <path d="M155.827 188.44H138.252V194.916H155.827V188.44Z" fill="#2C98F0" />
          <path
            d="M112.992 114.907V126.007C112.992 126.089 112.992 126.174 112.992 126.254C112.924 127.085 112.537 127.858 111.913 128.411C111.289 128.964 110.475 129.255 109.642 129.223C108.808 129.191 108.019 128.839 107.439 128.24C106.859 127.641 106.533 126.841 106.528 126.007V114.907C106.527 114.267 106.717 113.641 107.072 113.109C107.428 112.576 107.933 112.161 108.524 111.916C109.116 111.671 109.767 111.607 110.394 111.732C111.022 111.857 111.599 112.166 112.051 112.619L112.128 112.698C112.631 113.235 112.934 113.927 112.989 114.66C112.987 114.739 112.992 114.825 112.992 114.907Z"
            fill="#2C98F0"
          />
          <path
            d="M165.499 115.831V126.933C165.5 127.575 165.311 128.202 164.955 128.736C164.6 129.269 164.093 129.685 163.501 129.93C162.908 130.176 162.256 130.239 161.628 130.113C160.999 129.987 160.422 129.677 159.97 129.222L159.882 129.129C159.327 128.53 159.019 127.744 159.021 126.928V115.831C159.021 114.973 159.362 114.149 159.969 113.542C160.576 112.935 161.399 112.594 162.258 112.594C163.117 112.594 163.94 112.935 164.548 113.542C165.155 114.149 165.496 114.973 165.496 115.831H165.499Z"
            fill="#2C98F0"
          />
          <path
            d="M106.517 115.369V123.924C104.233 124.321 102.105 125.345 100.369 126.881C98.7565 128.373 97.5029 130.21 96.7022 132.256C95.6321 134.847 95.1122 137.727 94.9004 140.451C94.6377 144.126 94.8095 147.819 95.4121 151.454H86.1668C85.7734 146.34 85.8917 141.955 86.4088 138.187C86.981 133.939 88.0373 130.485 89.3769 127.673C92.0561 122.053 95.8687 119.003 99.2164 117.347C103.194 115.369 106.517 115.369 106.517 115.369Z"
            fill="#2C98F0"
          />
          <path
            d="M88.018 166.242C88.018 166.242 78.7232 157.294 86.1447 151.132H95.3625C95.3625 151.132 96.3418 166.242 88.018 166.242Z"
            fill="#2C98F0"
          />
          <path
            opacity="0.3"
            d="M88.018 166.242C88.018 166.242 78.7232 157.294 86.1447 151.132H95.3625C95.3625 151.132 96.3418 166.242 88.018 166.242Z"
            fill="black"
          />
          <path opacity="0.3" d="M151.662 112.597H120.216V136.644H151.662V112.597Z" fill="black" />
          <path opacity="0.3" d="M128.077 160.691H119.753V167.167H128.077V160.691Z" fill="black" />
          <path opacity="0.3" d="M128.077 172.718H119.753V181.042H128.077V172.718Z" fill="black" />
          <path opacity="0.3" d="M128.077 185.665H119.753V188.441H128.077V185.665Z" fill="black" />
          <path opacity="0.3" d="M153.048 160.691H144.725V167.167H153.048V160.691Z" fill="black" />
          <path opacity="0.3" d="M153.048 172.718H144.725V181.042H153.048V172.718Z" fill="black" />
          <path opacity="0.3" d="M153.048 185.665H144.725V188.441H153.048V185.665Z" fill="black" />
          <path
            opacity="0.3"
            d="M106.517 115.369V123.924C104.233 124.321 102.105 125.345 100.369 126.881L99.219 117.328C103.194 115.369 106.517 115.369 106.517 115.369Z"
            fill="black"
          />
          <path
            opacity="0.3"
            d="M96.7021 132.257C95.6321 134.848 95.1122 137.728 94.9004 140.451L86.406 138.176C86.9782 133.929 88.0345 130.474 89.3741 127.663L96.7021 132.257Z"
            fill="black"
          />
          <path
            d="M165.364 115.369V123.924C167.651 124.319 169.784 125.343 171.523 126.881C173.132 128.371 174.384 130.206 175.184 132.248C176.254 134.839 176.774 137.719 176.986 140.442C177.248 144.117 177.077 147.811 176.474 151.445H185.722C186.116 146.332 185.997 141.947 185.48 138.178C184.908 133.931 183.852 130.476 182.512 127.665C179.833 122.045 176.02 118.995 172.673 117.339C168.687 115.369 165.364 115.369 165.364 115.369Z"
            fill="#2C98F0"
          />
          <path
            d="M183.863 166.242C183.863 166.242 193.157 157.294 185.736 151.132H176.515C176.515 151.132 175.539 166.242 183.863 166.242Z"
            fill="#2C98F0"
          />
          <path
            opacity="0.3"
            d="M183.863 166.242C183.863 166.242 193.157 157.294 185.736 151.132H176.515C176.515 151.132 175.539 166.242 183.863 166.242Z"
            fill="black"
          />
          <path
            opacity="0.3"
            d="M165.364 115.369V123.924C167.651 124.319 169.784 125.343 171.523 126.881L172.673 117.328C168.687 115.369 165.364 115.369 165.364 115.369Z"
            fill="black"
          />
          <path
            opacity="0.3"
            d="M175.173 132.257C176.243 134.848 176.763 137.728 176.975 140.451L185.469 138.176C184.897 133.929 183.84 130.474 182.501 127.663L175.173 132.257Z"
            fill="black"
          />
          <path opacity="0.1" d="M141.487 102.422H130.388V103.189H141.487V102.422Z" fill="black" />
          <path
            opacity="0.1"
            d="M159.884 113.64V129.129C159.329 128.531 159.022 127.745 159.023 126.928V115.832C159.023 115.019 159.331 114.236 159.884 113.64Z"
            fill="black"
          />
          <path
            opacity="0.1"
            d="M112.981 114.66V126.254C112.926 126.987 112.622 127.679 112.12 128.215V112.698C112.622 113.235 112.926 113.927 112.981 114.66Z"
            fill="black"
          />
          <path opacity="0.1" d="M156.751 144.043H115.129V144.59H156.751V144.043Z" fill="black" />
          <path opacity="0.1" d="M134.55 156.069H114.202V156.493H134.55V156.069Z" fill="black" />
          <path opacity="0.1" d="M156.748 156.069H136.401V156.493H156.748V156.069Z" fill="black" />
        </Robot>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear"
          x1="135.939"
          y1="157.112"
          x2="135.939"
          y2="144.756"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
          <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint1_linear"
          x1="62835.8"
          y1="87367.7"
          x2="62835.8"
          y2="27924"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
          <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint2_linear"
          x1="9928.71"
          y1="28753.1"
          x2="9928.71"
          y2="22959.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
          <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
        </linearGradient>
        <linearGradient
          id="paint3_linear"
          x1="11295.7"
          y1="28753.1"
          x2="11295.7"
          y2="22959.2"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#808080" stopOpacity="0.25" />
          <stop offset="0.54" stopColor="#808080" stopOpacity="0.12" />
          <stop offset="1" stopColor="#808080" stopOpacity="0.1" />
        </linearGradient>
        <clipPath id="clip0">
          <rect width="282.924" height="207" fill="white" transform="translate(0.0761719)" />
        </clipPath>
      </defs>
    </svg>
  </div>
);

export default BotIllustration;
